<div data-theme="" class="lms-app-container app-wrapper">
  <main >
    <div class="card">
    <ng-content></ng-content>
    </div>
  </main>
</div>
